import { App } from "components";
import {
  BackgroundLoaderProvider,
  CuratedContext,
  HandshakeCareersContext,
  HiredTeacherPlacementContext,
  MappableContext,
  MayTermContext,
  NavPositionProvider,
  UserProvider,
} from "contexts";
import { createHashHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router";
import {
  fetchHandshakeCareers,
  getAllHiredPlacements,
  getAllInfo,
  getAllMayTerms,
  getStudentTeachersAndFaculty,
} from "services";
import "styles/fonts.scss";
import "styles/index.scss";
import { createCommaSeparatedList } from "utilities";

const requiredEnvContents = ["REACT_APP_GOOGLE_API_KEY", "REACT_APP_HANDSHAKE_API_KEY"];

const missingEnvContents: string[] = [];
requiredEnvContents.forEach(key => {
  if (!process.env[key]) {
    missingEnvContents.push(key);
  }
});
if (missingEnvContents.length > 0) {
  console.error(
    `Your local environment is missing the following keys: ${createCommaSeparatedList(
      missingEnvContents,
    )}. Make sure that you have an .env file in your root directory with the required contents.`,
  );
}

const historyConfig = {
  window,
};
// const history = createBrowserHistory(historyConfig);
const history = createHashHistory(historyConfig);

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <UserProvider>
        <BackgroundLoaderProvider
          numPages={1}
          fetchFn={getAllHiredPlacements}
          context={HiredTeacherPlacementContext}
        >
          <BackgroundLoaderProvider
            numPages={100}
            fetchFn={fetchHandshakeCareers}
            context={HandshakeCareersContext}
          >
            <BackgroundLoaderProvider numPages={1} fetchFn={getAllInfo} context={MappableContext}>
              <BackgroundLoaderProvider
                numPages={1}
                fetchFn={getAllMayTerms}
                context={MayTermContext}
              >
                <BackgroundLoaderProvider
                  numPages={1}
                  fetchFn={getStudentTeachersAndFaculty}
                  context={CuratedContext}
                >
                  <NavPositionProvider>
                    <App />
                  </NavPositionProvider>
                </BackgroundLoaderProvider>
              </BackgroundLoaderProvider>
            </BackgroundLoaderProvider>
          </BackgroundLoaderProvider>
        </BackgroundLoaderProvider>
      </UserProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root") || document.createElement("div"),
);
